import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getPopularTags } from "../../api/getSleeves";
import Skeleton from "react-loading-skeleton";

class PopularTagsContainer extends React.Component {
  componentDidMount() {
    this.props.request();
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const tags = (data && data.data.tags) || {};
    if (loading) {
      return <Skeleton count={3} />;
    }
    if (!loading && tags.length === 0) {
      return null;
    }
    return render({ tags, loading, failure });
  };
}

export default CreateContainer(getPopularTags, PopularTagsContainer);
